import { PROFESSIONAL_STATUS_PRE } from '@/define/consts/professional/professional_user';
import { POSITION_CANDIDATES, PROFESSIONAL_POSITION_CANDIDATES, SERVICE_CLIENT_PROFFIT, SERVICE_PROFESSIONAL_PROFFIT, SERVICE_PROFESSIONAL_PROFFIT_MART, SERVICE_PROFFIT_SEARCH, SERVICE_SEMINAR_ENABLE, TWO_FACTOR_AUTHENTICATION, } from '@/define/consts/profile';
/**
 * 「姓 名」を取得
 * @param profile
 */
export const getFullName = (profile) => {
    if (!profile) {
        return '';
    }
    const { firstName, lastName } = profile.information || {};
    return ((lastName || firstName) && `${lastName} ${firstName}`) || '';
};
/**
 * 「組織名」を取得
 * @param profile
 */
export const getOrganizationName = (profile) => { var _a; return ((_a = profile === null || profile === void 0 ? void 0 : profile.organization) === null || _a === void 0 ? void 0 : _a.name) || '-'; };
/**
 * 役職の文字列の取得
 * @param profile
 * @param isClient
 * @param isBr
 */
export const getPosition = (profile, isClient, isBr) => {
    var _a, _b;
    const rawPosition = (_a = profile === null || profile === void 0 ? void 0 : profile.information) === null || _a === void 0 ? void 0 : _a.position;
    const positionOther = (_b = profile === null || profile === void 0 ? void 0 : profile.information) === null || _b === void 0 ? void 0 : _b.positionOther;
    const position = parseInt(rawPosition, 10);
    let found;
    // 値に対応する役職の取得
    if (isClient) {
        found = POSITION_CANDIDATES.find((candidate) => candidate.value === position);
    }
    else {
        found = PROFESSIONAL_POSITION_CANDIDATES.find((candidate) => candidate.value === position);
    }
    if (found) {
        const isPositionOther = 'other' in found && found.other;
        if (isPositionOther) {
            return positionOther;
        }
        if (isBr && 'labelBr' in found && found.labelBr) {
            return found.labelBr;
        }
        return found.label;
    }
    return '';
};
/**
 * サービス利用可能かどうか判定
 * @param enableServices
 * @param name
 */
const judgeEnableService = (enableServices, name) => enableServices.some((v) => v.name === name && v.enableAt);
/**
 * サービスが審査利用可能かどうか判定
 * @param enableServices
 * @param name
 */
const judgeUnderExaminationService = (enableServices, name) => enableServices.some((v) => v.name === name && v.requestAt && !v.enableAt);
/**
 * ユーザ情報を元にサービスが利用可能かどうか判定
 * @param profile
 * @param name
 */
const judgeUserEnableService = (profile, name) => judgeEnableService((profile === null || profile === void 0 ? void 0 : profile.enableServices) || [], name);
/**
 * Client向けのProffitサービスが利用可能かどうか
 * @param profile
 */
export const isCanUseClientProffit = (profile) => judgeUserEnableService(profile, SERVICE_CLIENT_PROFFIT);
/**
 * 二要素認証が必要かどうか
 * @param profile
 */
export const isCanUseTwoFactorAuthentication = (profile) => judgeUserEnableService(profile, TWO_FACTOR_AUTHENTICATION);
/**
 * ProffitSearchを使用可能かどうか
 * @param profile
 */
export const isCanUseProffitSearch = (profile) => judgeUserEnableService(profile, SERVICE_PROFFIT_SEARCH);
/**
 * コンサルタント向けのProffitサービスが利用可能かどうか
 * @param profile
 */
export const isCanUseProfessionalProffit = (profile) => judgeUserEnableService(profile, SERVICE_PROFESSIONAL_PROFFIT);
/**
 * コンサルタント向けのProffitMartサービスが利用可能かどうか
 * @param profile
 */
export const isCanUseProfessionalProffitMart = (profile) => judgeUserEnableService(profile, SERVICE_PROFESSIONAL_PROFFIT_MART);
/**
 * Proffitサービスの審査中かどうか
 * @param profile
 */
export const isUnderExaminationProfessionalOrganizationProffit = (profile) => judgeUnderExaminationService((profile === null || profile === void 0 ? void 0 : profile.enableServices) || [], SERVICE_PROFESSIONAL_PROFFIT);
/**
 * Proffit Martサービスの審査中かどうか
 * @param profile
 */
export const isUnderExaminationProfessionalOrganizationProffitMart = (profile) => judgeUnderExaminationService((profile === null || profile === void 0 ? void 0 : profile.enableServices) || [], SERVICE_PROFESSIONAL_PROFFIT_MART);
/**
 * セミナーを申し込めるステータスかどうか
 * @param profile
 */
export const isCanUseProfessionalSeminar = (profile) => judgeEnableService(profile.profileType === 'professional'
    ? profile === null || profile === void 0 ? void 0 : profile.organizationEnableServices
    : [], SERVICE_SEMINAR_ENABLE);
/**
 * コンサルタントが仮会員ステータスかどうか
 * @param profile
 */
export const isProfessionalPreStatus = (profile) => (profile === null || profile === void 0 ? void 0 : profile.status) === PROFESSIONAL_STATUS_PRE;
/**
 * クライアントが仮会員ステータスかどうか
 * @param profile
 */
export const isClientPreStatus = (profile) => Object.keys(profile || {}).length > 0 && !isCanUseClientProffit(profile);
